// In order to keep core.module.ts as small as possible,
// router functionality is kept in this file.

// This is not done with other modules because it is conventient
// to have 'ng generate component' automatically add a component to
// the appropriate module by running it in that directory.

import { RouterModule, Routes } from '@angular/router';
import { QuicklinkStrategy } from 'ngx-quicklink';

import { HomeComponent } from './pages/home/home.component';
import { AuthGuard } from './security/auth.guard';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { Error404Component } from './pages/error404/error404.component';
import { LoginComponent } from './pages/login/login.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { EditUserComponent } from '../administration/users/edit-user/edit-user.component';
import { EditUserModule } from '../administration/users/edit-user/edit-user.module';
import { HelpFilesComponent } from '../help/help-files.component';
import { HelpVideosComponent } from '../help/help-videos/help-videos.component';
import { WebReleaseNotesComponent } from './pages/web-release-notes/web-release-notes.component';
import { MobileReleaseNotesComponent } from './pages/mobile-release-notes/mobile-release-notes.component';
import { ImportListComponent } from '../navient/import-list/import-list.component';
import { ChangeOldPasswordComponent } from './pages/change-old-password/change-old-password.component';
import { ClientsComponent } from 'app/clients/clients.component';
import { EditClientComponent } from 'app/clients/edit-client/edit-client.component';
import { LettercodeListComponent } from 'app/clients/lettercode-list/lettercode-list.component';
import { NixieListComponent } from '../nixies/nixie-list/nixie-list.component';
// This is the root of our navigation menu route definitions
const routes: Routes = [
	{ path: '', redirectTo: 'login', pathMatch: 'full' },
	{ path: 'login', component: LoginComponent },
	{ path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
	{ path: 'web-release-notes', component: WebReleaseNotesComponent, canActivate: [AuthGuard] },
	{ path: 'mobile-release-notes', component: MobileReleaseNotesComponent, canActivate: [AuthGuard] },
	{ path: 'edit-user/:id', component: EditUserComponent, canActivate: [AuthGuard] },
	{ path: 'forgot-password', component: ForgotPasswordComponent },
	{ path: 'change-password/:id', component: ChangePasswordComponent },
	{ path: 'change-old-password', component: ChangeOldPasswordComponent },
	// tslint:disable-next-line:max-line-length
	{
		path: 'clients',
		canActivate: [AuthGuard],
		component: ClientsComponent,
	},
	{
		path: 'clients/edit-client/:id',
		canActivate: [AuthGuard],
		component: EditClientComponent,
	},
	{
		path: 'lettercodes',
		canActivate: [AuthGuard],
		component: LettercodeListComponent,
	},
	{
		path: 'administration',
		canLoad: [AuthGuard],
		loadChildren: () => import('../administration/administration.module').then(m => m.AdministrationModule),
	},
	{
		path: 'style-guide',
		loadChildren: () => import('../style-guide/style-guide.module').then(m => m.StyleGuideModule),
	},
	{
		path: 'help',
		canActivate: [AuthGuard],
		component: HelpFilesComponent,
		data: { security: 'securityHelpFiles.listAccess' },
	},
	// tslint:disable-next-line:max-line-length
	{
		path: 'help/help-video/:id',
		canActivate: [AuthGuard],
		component: HelpVideosComponent,
		data: { security: 'securityHelpFiles.listAccess' },
	},
	{
		path: 'navient',
		canLoad: [AuthGuard],
		canActivate: [AuthGuard],
		component: ImportListComponent,
	},
	{
		path: 'nixie-list',
		canActivate: [AuthGuard],
		component: NixieListComponent,
	},
	{ path: '**', redirectTo: '' },
];

export class CoreRouting {
	static declarations = [
		HomeComponent,
		DashboardComponent,
		LoginComponent,
		Error404Component,
		ForgotPasswordComponent,
		ChangePasswordComponent,
		ChangeOldPasswordComponent,
		HelpFilesComponent,
		HelpVideosComponent,
		ImportListComponent,
	];
	// tslint:disable-next-line:max-line-length
	static imports = [
		RouterModule.forRoot(routes, {
			scrollPositionRestoration: 'enabled',
			preloadingStrategy: QuicklinkStrategy,
		}),
		EditUserModule,
	];
	static exports = [RouterModule];
	static providers = [AuthGuard];
}
